export default "__VITE_ASSET__BlherPAw__"